import { cva } from "class-variance-authority"

const iconSize = {
  medium: "size-5",
  large: "size-6",
}

const labelSize = {
  medium: "font-medium-400",
  large: "font-large-400",
}

export type CheckboxSize = keyof typeof iconSize

export const checkboxSizeKeys = Object.keys(iconSize) as CheckboxSize[]

export const checkboxContainerVariants = cva(
  "relative inline-flex w-fit cursor-pointer items-start gap-x-2 has-[:disabled]:cursor-not-allowed"
)

export const checkboxIconVariants = cva(
  "shrink-0 rounded-sm text-icon-general-secondary peer-checked:text-icon-general-primary peer-indeterminate:text-icon-general-primary peer-focus-visible:outline peer-focus-visible:outline-1 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-semantic-interaction-selected peer-disabled:text-icon-general-disabled",
  {
    variants: {
      size: iconSize,
      // Applied to the empty box only (see Checkbox.svelte), where the icon is
      // an outline — so error reads as a red border, not a red block.
      error: {
        true: "text-icon-general-error",
      },
    },
    defaultVariants: {
      size: "medium",
    },
  }
)

// No error variant: the label keeps its normal colour when the checkbox is
// invalid. The box's border carries the signal, the message belongs to `Field`.
export const checkboxLabelVariants = cva(
  "text-icon-general-secondary peer-checked:text-icon-general-primary peer-indeterminate:text-icon-general-primary peer-disabled:text-icon-general-disabled",
  {
    variants: {
      size: labelSize,
    },
    defaultVariants: {
      size: "medium",
    },
  }
)
